import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import { VueCookieNext } from 'vue-cookie-next'
import axios from 'axios'
import VueAxios from 'vue-axios'

createApp(App).use(store).use(router).use(i18n).use(VueCookieNext).use(VueAxios, axios).mount('#app')